import { API, TOKEN_NAME } from "./Constants";

class Auth {
  static login(email_address, password) {
    return fetch(API + "/admin_sessions", {
      body: JSON.stringify({
        email_address: email_address,
        password: password,
      }),
      headers: { "content-type": "application/json" },
      method: "POST",
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        } else {
          // Try to parse error message from response
          return resp
            .json()
            .then((errorData) => {
              const errorMessage =
                errorData.error || errorData.message || resp.statusText;
              throw Error(errorMessage);
            })
            .catch((parseError) => {
              // If JSON parsing fails, use status-based messages
              if (resp.status === 401) {
                throw Error("Invalid email or password");
              } else if (resp.status === 404) {
                throw Error("Login service not found");
              } else if (resp.status >= 500) {
                throw Error("Server error. Please try again later.");
              } else {
                throw Error(resp.statusText || "Login failed");
              }
            });
        }
      })
      .then((json) => {
        localStorage.setItem(TOKEN_NAME, json.data.id);
        return Promise.resolve(json);
      })
      .catch((error) => {
        // Handle network errors
        if (error.message === "Failed to fetch" || error.name === "TypeError") {
          throw Error("Network error. Please check your connection.");
        }
        throw error;
      });
  }

  static isLoggedIn() {
    const token = localStorage.getItem(TOKEN_NAME);
    if (!token) {
      return Promise.resolve(false);
    } else {
      return fetch(API + "/admin_sessions/" + token, {
        headers: { "content-type": "application/json" },
      })
        .then((resp) => {
          if (resp.ok) {
            return resp.json();
          } else {
            return Promise.resolve(false);
          }
        })
        .catch((error) => {
          // Handle network errors gracefully
          console.error("Error checking login status:", error.message);
          return Promise.resolve(false);
        });
    }
  }

  static logout() {
    const token = localStorage.getItem(TOKEN_NAME);
    return fetch(API + "/admin_sessions/" + token, {
      headers: { "content-type": "application/json" },
      method: "DELETE",
    }).then((resp) => {
      localStorage.removeItem(TOKEN_NAME);
      if (!resp.ok) {
        throw Error(resp.statusText);
      }
    });
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/Auth.js